import React from "react";
import { Box, Typography } from "@mui/material";
import StyledButton from "../components/Styled/StyledButton";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100vw",
        height: "100vh",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Typography variant="h5">ขออภัยไม่พบข้อมูลที่คุณกำลังค้นหา</Typography>
      <StyledButton
        variant="outlined"
        title="กลับหน้าหลัก"
        sx={{ mt: 3, mb: 10 }}
        onClick={() => navigate("/")}
      />
      <img src="/static/notFoundPic.svg" alt="Not Found" />
    </Box>
  );
};

export default NotFound;
